import { render, staticRenderFns } from "./ResourceHall.vue?vue&type=template&id=5f91862a&scoped=true"
import script from "./ResourceHall.vue?vue&type=script&lang=js"
export * from "./ResourceHall.vue?vue&type=script&lang=js"
import style0 from "./ResourceHall.vue?vue&type=style&index=0&id=5f91862a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f91862a",
  null
  
)

export default component.exports